// What the operator quotes to support when Power refused a call: the error code and the trace id
// of the answer, inside the alert that says what failed (it has no role of its own). The trace id
// is selected whole on a click, to be copied as it is.
import { OPERATOR_ORGANIZATION_UNRESOLVED_CODE } from '@finnest/power-admin-contracts/failure';
import type { PowerRefusal } from '@finnest/power-admin-contracts/failure';

export const FAILURE_REFERENCE_LABELS = {
  code: 'Código do erro',
  traceId: 'Id de rastreio',
} as const;

const NONE = '—';

/** Why every deployment screen is unavailable when Power IAM names no single operator organization. */
export const OPERATOR_ORGANIZATION_CAUSE =
  'O Power IAM não tem exatamente uma organização operadora (self-hosted): provisione o proprietário dela com finnest admin owner create. Até lá, as telas da implantação ficam indisponíveis.';

export const FailureReference = ({ refusal }: { readonly refusal: PowerRefusal }): JSX.Element => (
  <>
    {refusal.code === OPERATOR_ORGANIZATION_UNRESOLVED_CODE ? (
      <p className="admin-failure-cause">{OPERATOR_ORGANIZATION_CAUSE}</p>
    ) : null}
    <dl className="admin-failure-reference">
      <div>
        <dt>{FAILURE_REFERENCE_LABELS.code}</dt>
        <dd>
          <code>{refusal.code}</code>
        </dd>
      </div>
      <div>
        <dt>{FAILURE_REFERENCE_LABELS.traceId}</dt>
        <dd>
          {refusal.traceId === null ? (
            NONE
          ) : (
            <code className="admin-failure-reference-trace">{refusal.traceId}</code>
          )}
        </dd>
      </div>
    </dl>
  </>
);
